import { render, staticRenderFns } from "./pl3.vue?vue&type=template&id=770cd7f1&scoped=true"
var script = {}
import style0 from "./pl3.vue?vue&type=style&index=0&id=770cd7f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770cd7f1",
  null
  
)

export default component.exports